import $ from 'jquery';
import { sleepFor, getParameterByName } from '../_shared/helpers';

export default class MCDatepicker {
    constructor(element, index = 1) {
        this.$datepickerInput = $(element);
        this.$formFieldInput = this.$datepickerInput.parent().find('.datepickerHiddenField');
        this.pastDates = this.$datepickerInput.data('past-dates');
        this.autoFillDisabled = this.$datepickerInput.data('autofill-disabled');

        this.index = index;
        this.checkRetry = 0;
        this.checkDelay = 1000;
        this.lang = $('html').attr('lang');

        this.datepickerInstance = null;

        this.selectedDate = null;
        this.confirmedDate = null;
        this.initDate = this.autoFillDisabled ? null : new Date();

        this.defaultPosition = 'bottom center';
        this.dateFormat = 'd M yyyy';

        this.datepickerWrapper = this.$datepickerInput.closest('.js-datepicker');
        this.submitOnSelect = Boolean(this.datepickerWrapper.data('auto-submit'));
        this.useLocalTime = Boolean(this.datepickerWrapper.data('localtime'));
        this.$datepickerLink = this.datepickerWrapper.find('.js-datepicker-link');

        this.linkInitiaed = false;

        this.init();
    }

    async init() {
        const pluginLoaded = await this.checkDatePickerPluginLoaded();

        if (pluginLoaded) {
            this.initDatePicker();
            this.attachEventListeners();
        } else {
            console.error('$.fn.datepicker isn\'t loaded');
        }
    }

    async checkDatePickerPluginLoaded() {
        if (this.checkRetry > 2) {
            return false;
        }
        this.checkRetry += 1;
        if (!$.fn.datepicker) {
            await sleepFor(this.checkDelay);
            return this.checkDatePickerPluginLoaded();
        }
        return true;
    }

    initDatePicker() {
        const self = this;
        const { $datepickerInput, pastDates } = this;

        if ($datepickerInput.attr('id') == null) {
            $datepickerInput.attr('id', `datepicker_${this.index + 1}`);
        }
        $datepickerInput.datepicker({
            dateFormat: this.dateFormat,
            language: self.lang,
            autoClose: true,
            toggleSelected: false,
            minDate: pastDates ? null : new Date(),
            onShow() { self.setPosition(); },
            onHide() { self.confirmDate(); },
            onSelect(date) {
                self.selectedDate = date || self.initDate;
            },
        });

        this.datepickerInstance = $datepickerInput.data('datepicker');
        this.handleQueryParams();
        if ($datepickerInput.val()) {
            this.datepickerInstance.selectDate(new Date($datepickerInput.val()));
        } else {
            this.datepickerInstance.selectDate(this.initDate);
        }
    }

    setFormFieldInput(date) {
        if (this.$formFieldInput.length) {
            this.$formFieldInput.val(MCDatepicker.setSearchDate(date));
            this.datepickerInstance.update({ dateFormat: this.dateFormat });
        }
    }

    confirmDate() {
        if (this.selectedDate) {
            this.confirmedDate = new Date(this.selectedDate);
            this.setFormFieldInput(this.confirmedDate);
            this.selectedDate = null;
            const $form = this.datepickerWrapper.closest('form');
            MCDatepicker.animateBtn($form, 'ff-tours-finder__btn');
            if (this.submitOnSelect && this.linkInitiaed) {
                this.linkInitiaed = false;
                this.datepickerWrapper.closest('form').trigger('submit');
            }
        }
    }

    closeDatePicker() {
        this.datepickerInstance.hide();
    }

    attachEventListeners() {
        if (this.submitOnSelect && this.$datepickerLink.length) {
            this.$datepickerLink.on('click', (e) => {
                e.preventDefault();
                this.datepickerInstance.show();
                if (this.submitOnSelect) {
                    this.linkInitiaed = true;
                }
            });
        }

        $(window).on('resize', () => {
            this.datepickerInstance.hide();
        });
    }

    setPosition() {
        const baseEl = this.$datepickerLink.length ? this.$datepickerLink[0] : this.$datepickerInput[0];
        const rect = baseEl.getBoundingClientRect();
        const datepickerWidth = this.datepickerInstance.$datepicker[0].offsetWidth;
        const datepickerHeight = this.datepickerInstance.$datepicker[0].offsetHeight;
        let position = this.defaultPosition;
        let horz = 'center';
        let vert = 'bottom';

        if (window.innerWidth - rect.right < datepickerWidth) {
            horz = 'right';
        }
        if (rect.left < datepickerWidth && rect.right < datepickerWidth) {
            horz = 'left';
        }
        if (window.innerHeight - datepickerHeight < rect.bottom && datepickerHeight < rect.top) {
            vert = 'top';
        }

        position = `${vert} ${horz}`;

        this.datepickerInstance.update({ position });

        /* trick for arabic version */
        if (this.lang === 'ar') {
            const left = $(this.datepickerInstance.$datepicker[0]).css('left');
            $(this.datepickerInstance.$datepicker[0]).css('left', '0px');
            $(this.datepickerInstance.$datepicker[0]).css('right', left);
        }
    }

    handleQueryParams() {
        const fromDate = getParameterByName('fromDate');
        if (fromDate) {
            const fromDateObj = new Date(fromDate);
            const date = this.useLocalTime ? fromDateObj : new Date(fromDateObj.getTime() + fromDateObj.getTimezoneOffset() * 60000);
            if (date instanceof Date && !Number.isNaN(date) && date.toString() !== 'Invalid Date' && date.getFullYear() <= 9999) {
                this.initDate = date;
            }
        }
    }

    static setSearchDate(date) {
        const searchDate = this.useLocalTime ? new Date(date.getTime() - date.getTimezoneOffset() * 60000) : date;
        const year = searchDate.getFullYear();
        const month = String(searchDate.getMonth() + 1).padStart(2, '0');
        const day = String(searchDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    static animateBtn($context, className) {
        $context.find(`.${className}`).addClass(`${className}-pulse`);
        setTimeout(() => {
            $context.find(`.${className}`).removeClass(`${className}-pulse`);
        }, 1250);
    }
}
